import React, { useState, useEffect } from 'react';

const TCSReportAllPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});

  // Get URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedParams = {
      fromDate: urlParams.get('fromDate') || '',
      toDate: urlParams.get('toDate') || '',
      branchId: urlParams.get('branchId') || '',
      taxType: urlParams.get('taxType') || ''
    };
    setParams(extractedParams);
  }, []);
  console.log("params:",params);

  // Default data structure for fallback
  const defaultReportData = {
    branchName: "HEAD-OFFICE",
    fromDate: "01/04/2022",
    toDate: "18/08/2025 12:00:00AM",
    items: [],
    totalCostAmount: "₹0.00",
    totalSGSTAmount: "₹0.00",
    totalIGSTAmount: "₹0.00",
    totalAmount: "₹0.00",
    totalRecords: 0
  };

  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      if (!params.branchId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Build API URL with parameters
        const apiUrl = `https://www.nissi-india.com/api/tcsReportForListing?fromdate=${params.fromDate}&todate=${params.toDate}&branchId=${params.branchId}&taxType=${params.taxType}`;

        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        console.log("Fetched GST data:", res);
        
        // Check if API call was successful
        if (!res.success && res.success !== undefined) {
          throw new Error('API returned unsuccessful response');
        }

        // Format date function
        const formatDate = (dateString) => {
          if (!dateString) return '';
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        };

        // Transform API data to match our component structure
        const apiData = res.data || [];
        const totaldata= res.totals || {};
        
        const transformedData = {
          branchName: apiData[0]?.fld_BranchName || "HEAD-OFFICE",
          fromDate: formatDate(params.fromDate) || "01/04/2022",
          toDate: formatDate(params.toDate) || "18/08/2025",
          totalRecords: apiData.length,
          items: apiData.map((item, index) => ({
            sNo: index + 1,
            supplierName: item.fld_Suppliername || item.SupplierName||"",
            gstNo: item.fld_TIN || "",
            grnNo: item.fld_GRNno || "",
            invoiceNo: item.fld_invno || "",
            invoiceDate: formatDate(item.GRNDate) || "",
            accessibleAmount: item.AccAmtNew ,
            costAmount: item.CGSTAmountNew || item.CGSTAmount,
            sgstAmount: item.SGSTAmountNew || item.SGSTAmount,
            igstAmount: item.IGSTAmountNew || item.IGSTAmount,
            totalAmount: item.TotalAmountNew || item.TotalAmount ,
          
          })),
        };

        // Calculate totals
       const totals = {
  costAmount: totaldata.cgst || 0,  // CGST as Cost Amount (since your table shows COST)
  sgstAmount: totaldata.sgst || 0,
  igstAmount: totaldata.igst || 0,
  totalAmount: totaldata.grand || 0
};

transformedData.totalCostAmount = `₹${totals.costAmount.toFixed(2)}`;
transformedData.totalSGSTAmount = `₹${totals.sgstAmount.toFixed(2)}`;
transformedData.totalIGSTAmount = `₹${totals.igstAmount.toFixed(2)}`;
transformedData.grandTotal = `₹${totals.totalAmount.toFixed(2)}`;

        setReportData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching GST report data:', err);
        setError(err.message);
        setReportData(defaultReportData);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [params]);

  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading GST report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load GST report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning (if using fallback data) */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Could not fetch data from API ({error}). Showing template.
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center border-b-2 border-black pb-2 mb-4 print:border-black">
          <h2 className="text-lg font-bold underline">TCS REPORT</h2>
        </div>

        {/* Report Summary */}
        <div className="grid grid-cols-2 gap-x-8 mb-4 text-sm">
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-20">Branch</span>
              <span className="mr-2">:</span>
              <span>{reportData.branchName}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-20">From</span>
              <span className="mr-2">:</span>
              <span>{reportData.fromDate}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-20">To</span>
              <span className="mr-2">:</span>
              <span>{reportData.toDate}</span>
            </div>
          </div>
        </div>

        {/* GST Table */}
        <div className="border-2 border-black mb-4 print:border-black overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-1 py-2 text-center w-12 print:border-black">Sl.No</th>
                <th className="border border-black px-1 py-2 text-center w-32 print:border-black">Suppliername</th>
                <th className="border border-black px-1 py-2 text-center w-24 print:border-black">GST No</th>
                <th className="border border-black px-1 py-2 text-center w-24 print:border-black">GRN No</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Invoice No</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Invoice Date</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Accessible Amount</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">COST Amount</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">SGST Amount</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">IGST Amount</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total Amount</th>
       
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-1 py-1 print:border-black">{item.supplierName}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.gstNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.grnNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.invoiceNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.invoiceDate}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.accessibleAmount}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.costAmount}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.sgstAmount}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.igstAmount}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.totalAmount}</td>
              
                </tr>
              ))}

              {/* Totals Row */}
              {reportData.items.length > 0 && (
                <tr className="bg-gray-50 font-bold">
                  <td className="border border-black px-1 py-2 print:border-black" colSpan="7"></td>
                  <td className="border border-black px-1 py-2 text-right print:border-black">
                    {reportData.totalCostAmount}
                  </td>
                  <td className="border border-black px-1 py-2 text-right print:border-black">
                    {reportData.totalSGSTAmount}
                  </td>
                  <td className="border border-black px-1 py-2 text-right print:border-black">
                    {reportData.totalIGSTAmount}
                  </td>
                  <td className="border border-black px-1 py-2 text-right print:border-black">
                    {reportData.grandTotal}
                  </td>
                  <td className="border border-black px-1 py-2 print:border-black" colSpan="2"></td>
                </tr>
              )}

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="13">
                    <div className="text-gray-500">
                      No GST records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 9px !important;
          }
          .text-green-600 {
            color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TCSReportAllPrint;